import $ from "jquery";
import '../scss/app.scss';
import './search.js';
import './publications.js';
import './newsletter.js';


// import bootstrap from 'bootstrap';
import '../../node_modules/bootstrap/js/dist/util';
import '../../node_modules/bootstrap/js/dist/collapse';
import './modules/bloc-slider';
import './modernizr.js';


// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

import BigPicture from 'bigpicture';


require('smartmenus');
// require('smartmenus-keyboard');

import '../../node_modules/selectric';


$(function () {
  $('html').removeClass('no-js');
  $('html').addClass('js');

  //Add the following code after jquery. This will fix it and removes the Pagespeed warning
  $.event.special.touchstart = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };
  $.event.special.touchmove = {
    setup: function (_, ns, handle) {
      this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };
  $.event.special.wheel = {
    setup: function (_, handle) {
      this.addEventListener("wheel", handle, { passive: true });
    }
  };
  $.event.special.mousewheel = {
    setup: function (_, handle) {
      this.addEventListener("mousewheel", handle, { passive: true });
    }
  };


  if ($('html').hasClass('no-flexbox')) {
    $("#avertissement").addClass('show');
    $('html').addClass('hide_scroll');
  }




  //---------------------------//
  // ===== NUMBER ANIMATION ====
  //---------------------------//
  function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);

      let number = null;;
      if (end % 1 !== 0) {
        // nombre avec décimal
        number = (progress * (end - start)).toFixed(2);
      } else {
        number = Math.floor(progress * (end - start));
      }

      obj.querySelector(".figureKeys__number").innerHTML = number;

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  const figureKeys = document.querySelectorAll(".figureKeys");
  figureKeys.forEach(function (el) {
    // define an observer instance
    var observer = new IntersectionObserver(onIntersection, {
      root: null,   // default is the viewport
      threshold: .5 // percentage of taregt's visible area. Triggers "onIntersection"
    })

    // callback is called on intersection change
    function onIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting === true && entry.target.classList.contains('visible') === false) {
          entry.target.classList.add('visible');
          animateValue(el, el.dataset.start, el.dataset.end, 1500);
        }
      });
    }

    // Use the observer to observe an element
    observer.observe(el);

  });







  //---------------------------//
  // ===== NEWSLETTER ====
  //---------------------------//


  const newsletterSection = $('#section-newsletter');
  const modalNewsletter = $('#modal-newsletter');

  $('#fixed-link-newsletter').click(function () {
    if (newsletterSection.length > 0) {
      $('body,html').animate({
        scrollTop: newsletterSection.offset().top - $('.site-header').height()
      }, 500);
    } else {
      // Get the modal
      modalNewsletter.fadeIn('slow');
    }
  });

  $('.openNewsletterText').click(function () {
    $('.bloc-newsletter__info .entry-content').slideToggle();
  });

  // When the user clicks anywhere outside of the modal, close it
  $(document).click(function (event) {
    if (event.target === modalNewsletter[0]) {
      modalNewsletter.fadeOut('slow');
    }
  })


  $(document).on("click", ".close-modal", function () {
    $(this).parent().fadeOut('slow');
  })



  //---------------------------//
  // ===== // Scroll page button to a specific div with smooth scroll ====
  //---------------------------//

  var offsetSize = $(".header-sticky").innerHeight();
  offsetSize = offsetSize + 30;
  $('a[href*=\\#]').on('click', function (e) { // Au clic sur un élément

    var target = this.hash;
    var $target = $(target);

    var targetname = target.slice(1, target.length);

    if (document.getElementById(targetname) != null) { //if element is present in page
      e.preventDefault();

      $('html, body').stop().animate({
        'scrollTop': $target.offset().top - offsetSize //or the height of your fixed navigation 

      }, 900);
    }
  });
  if (window.location.hash.length !== 0) {
    $("html, body").animate({ scrollTop: $(window.location.hash).offset().top - offsetSize }, 750);
  }


  //---------------------------//
  // ===== Scroll to Top ====
  //---------------------------//

  if ($('#return-to-top').length > 0) {

    $(window).scroll(function () {

      if ($(this).scrollTop() >= 400) {        // If page is scrolled more than 400
        $('#return-to-top').fadeIn(200);    // Fade in the arrow
      } else {
        $('#return-to-top').fadeOut(200);   // Else fade out the arrow
      }
    });

    $('#return-to-top').click(function () {      // When arrow is clicked
      $('body,html').animate({
        scrollTop: 0                       // Scroll to top of body
      }, 500);
    });
  }




  //---------------------------//
  // MENU 
  //---------------------------//
  if ($('.main-menu').length > 0) {
    $('.main-menu').smartmenus({
      subMenusMaxWidth: '24rem',
      subMenusMinWidth: '24rem',
      collapsibleBehavior: "accordion-link",
      keepInViewport: true,
      scrollAccelerate: true,
    });


    // sub menu animation
    $('.main-menu').bind({
      'show.smapi': function (menu) {
        $(menu).removeClass('hide-animation').addClass('show-animation');
      },
      'hide.smapi': function (menu) {
        $(menu).removeClass('show-animation').addClass('hide-animation');
      }
    }).on('animationend webkitAnimationEnd oanimationend MSAnimationEnd', 'ul', function (e) {
      $(this).removeClass('show-animation hide-animation');
      e.stopPropagation();
    });


    var $mainMenuState = $('.main-menu-btn');


    if ($mainMenuState.length) {
      // animate mobile menu
      $mainMenuState.on("click", function () {
        if ($(this).parent().hasClass('open-menu') === true) {
          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);

        } else {
          document.body.style.top = '-' + window.scrollY + 'px';
          document.body.style.position = 'fixed';
        }
        $('.overlay-menu').fadeToggle();
        $(this).parent().toggleClass('open-menu');
        $(this).parent().find('.wrapper-menu').slideToggle(250);

      });

      // $mainMenuState.change(function () {

      //   if (this.checked) {
      //     $mainMenuState.addClass('open-menu');
      //     $menu.hide().slideDown(250, function () { $menu.css('display', ''); });
      //   } else {
      //     $menu.show().slideUp(250, function () { $menu.css('display', ''); });
      //     $mainMenuState.removeClass('open-menu');
      //   }
      // });
      // hide mobile menu beforeunload
      $(window).on('beforeunload unload', function () {
        if ($mainMenuState[0].checked) {
          $mainMenuState[0].click();
        }
      });

    }
  }

  //---------------------------//
  // Gallery LIGHTVIEW
  //---------------------------//
  // opens gallery w/ all three images
  // if (document.querySelector('.blocks-gallery-grid figure > a') !== null) {
  //   $(document).on("click", ".blocks-gallery-grid figure > a", function (e) {
  //     e.preventDefault();
  //     BigPicture({
  //       el: e.target,
  //       galleryAttribute: 'data-full-url',
  //       gallery: '.blocks-gallery-grid',
  //     })
  //   });
  // }

 // image lightview
  // if (document.querySelector('.wp-block-gallery figure > a') !== null) {
  //   $(document).on("click", ".wp-block-gallery figure > a", function (e) {
  //     e.preventDefault();

  //     const target =  e.target ;
  //     var parent = target.parentElement;

  //     console.log( parent.getAttribute('href'));

  //     BigPicture({
  //       el: e.target,
  //     })
  //   });
  // }


  // opens gallery w/ all three images
  // if (document.querySelector('.wp-block-media-text__media > a, .wp-block-image > a') !== null) {
  //   $(document).on("click", ".wp-block-media-text__media > a, .wp-block-image > a", function (e) {
  //     e.preventDefault();
  //     let href = e.currentTarget.getAttribute('href');
      

  //     if (href.includes('wp-content/uploads') === true || href.includes('?attachment_id') === true) {
  //       BigPicture({
  //         el: e.target
  //       })
  //     } else {
  //       window.location.href = href;
  //     }
  //   });
  // }

  //---------------------------//
  // VIDEO LIGHTVIEW
  //---------------------------//


  if (document.querySelector('.video-lightview') !== null) {
    $(document).on("click", ".video-lightview", function (e) {
      e.preventDefault();
      var className = e.currentTarget.className;
      var videoId = e.currentTarget.getAttribute('data-src');

      if (~className.indexOf('htmlvid')) {
        BigPicture({
          el: e.currentTarget,
          vidSrc: e.currentTarget.getAttribute('src'),
        })
      } else if (~className.indexOf('vimeo')) {

        var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
        var parseUrl = regExp.exec(videoId);
        videoId = parseUrl[5];
        BigPicture({
          el: e.currentTarget,
          vimeoSrc: videoId,
        })
      } else if (~className.indexOf('youtube')) {
        videoId = videoId.split('v=')[1];
        var ampersandPosition = videoId.indexOf('&');
        if (ampersandPosition !== -1) {
          videoId = videoId.substring(0, ampersandPosition);
        }

        BigPicture({
          el: e.currentTarget,
          ytSrc: videoId,
        })
      }
    });
  };



  //---------------------------//
  // Decallage des colonnes dans gutemberg
  //---------------------------//
  function colonneDecalage() {
    if ($(window).width() > 768) {
      var firstElement = $('.entry-content *:eq(0)');

      if ($(firstElement[0]).hasClass('is-style-columns-over') === true) {
        $('.hero-header').addClass('hero-more-space');
      };
    } else {
      $('.hero-header').removeClass('hero-more-space');
    }
  }

  colonneDecalage();



  //---------------------------//
  // Pour rendre la map carrée
  //---------------------------//
  function square() {
    let el = $('.square');
    el.each(function (index) {
      let elWidth = $(el[index]).outerWidth();
      $(el[index]).css('height', elWidth);
    });
  }

  square();

  $(window).on('resize', function () {
    colonneDecalage();
    square();
  });

  //---------------------------//
  // slider acf dans gutemberg
  //---------------------------//
  $(".slider-acf").each(function () {
    $(this).sliderAcf();
  });


  //---------------------------//
  // slider Evenement home
  //---------------------------//

  var loop = false;
  var centeredSlidesEvent = true;
  if ($(".swiper-event .swiper-slide").length > 1) {
    loop = true
    centeredSlidesEvent = false;
  }

  new Swiper('.swiper-event', {
    // Optional parameters
    loop: loop,
    slidesPerView: '1.1',
    centeredSlides: true,
    grabCursor: true,
    breakpoints: {
      // when window width is >= 640px
      600: {
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: centeredSlidesEvent,
      }
    }
  });



  //---------------------------//
  // slider Spotlight
  //---------------------------//
  let loopSpotlight = false;

  if (document.querySelector('.swiper-spotlight')) {
    
    const spotlightNavigation = document.querySelector('.swiper-spotlight .swiper-navigation-footer');
    if ($(".swiper-spotlight .swiper-slide").length > 1) {
      loopSpotlight = true;
      spotlightNavigation.classList.remove('d-none');
    } else {
      spotlightNavigation.classList.add('d-none');
    }


    new Swiper('.swiper-spotlight', {
      // Optional parameters
      loop: loopSpotlight,
      slidesPerView: '1',
      centeredSlides: true,
      grabCursor: true,
      speed: 600,
      autoHeight: true,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-spotlight-next',
        prevEl: '.swiper-spotlight-prev',
      },
    });

  }


  //---------------------------//
  // slider publication
  //---------------------------//
  var loopPublication = false;
  if ($(".swiper-publication .swiper-slide").length > 3) {
    loopPublication = true
  }


  new Swiper('.swiper-publication', {
    // Optional parameters
    loop: true,
    slidesPerView: '1.1',
    centeredSlides: true,
    grabCursor: true,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-publication-next',
      prevEl: '.swiper-publication-prev',
    },

    breakpoints: {
      // when window width is >= 640px
      600: {
        slidesPerView: 'auto',
        loop: loopPublication
      }
    }
  });


  let loopSameTheme = false;
  let centeredSlides = false;
  let initialSlide = 0;
  if ($(".swiper-same-theme .swiper-slide").length >= 3) {
    loopSameTheme = true;
    centeredSlides = true;
    initialSlide = 1;
  } else {
    $(".swiper-same-theme .swiper-wrapper").addClass('center-slide');
  }

  new Swiper('.swiper-same-theme', {
    // Optional parameters
    loop: loopSameTheme,
    slidesPerView: '1.1',
    centeredSlides: true,
    grabCursor: true,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // when window width is >= 640px
      600: {
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: centeredSlides,
        initialSlide: initialSlide,
        //  centerInsufficientSlides: true
      },

      992: {
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: false,
        initialSlide: 0
      }
    }
  });


  //---------------------------//
  // slider actualité
  //---------------------------//
  let slideView = $('.swiper-news .swiper-slide').outerWidth();
  new Swiper('.swiper-news', {
    // Optional parameters
    loop: true,
    slidesPerView: '1.1',
    centeredSlides: true,
    grabCursor: true,
    initialSlide: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      // when window width is >= 640px
      600: {
        slidesPerView: 'auto'
      },
      990: {
        slidesPerView: 'auto',
        centeredSlides: true,
        slidesOffsetBefore: slideView / 2
      }
    }
  });



  //---------------------------//
  // slider hero on home page
  //---------------------------//
  new Swiper('.swiper-hero', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    grabCursor: true,
    autoplay: {
      delay: 4000,
    },
    // Navigation arrows
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
  })





  //---------------------------//
  // CUSTOM SELECT
  //---------------------------//
  $('select').selectric({
    multiple: {
      separator: ', ',       // Type: String.             Description: Items separator.
      keepMenuOpen: true,    // Type: Boolean.            Description: Close after an item is selected.
      maxLabelEntries: false // Type: Boolean or Integer. Description: Max selected items do show.
    }
  });


  //---------------------------//
  // sur mobile
  //---------------------------//
  $('#openFilteSearch').click(function () {
    $('.filters-search').slideToggle();
    $('#openFilteSearch').toggleClass('open');
  });


  $('#openFilteCategory').click(function () {
    $('.filter-category-container-tag').slideToggle();
    $('#openFilteCategory').toggleClass('open');
  });





  //---------------------------//
  // STICKY HEADER
  //---------------------------//

  let header = $('.site-header');
  let headerHeight = header.outerHeight();

  document.addEventListener("scroll", function () {
    let scrollHeight = document.body.scrollTop || document.documentElement.scrollTop;
    if (scrollHeight >= (headerHeight + 3)) {
      header.addClass('sticky-show');
    } else if (scrollHeight >= (headerHeight - 10)) {
      header.removeClass('sticky-show');
    }
  }, { passive: true });


  let wrapperMenu = document.querySelector('.site-header .wrapper-menu');
  wrapperMenu.style.maxHeight = (window.innerHeight - headerHeight) + "px";



});
